import { motion } from "framer-motion";

export const LogoMark = ({ className = "h-7 w-auto", draw = false }) => {
  const p = draw
    ? { initial: { pathLength: 0 }, animate: { pathLength: 1 }, transition: { duration: 1.4, ease: "easeInOut" } }
    : {};
  return (
    <svg viewBox="0 0 64 50" className={className} aria-hidden="true">
      <motion.path d="M2 44 L20 18 L28 28 L37 12 L44 22" fill="none" stroke="#fff" strokeWidth="5" strokeLinejoin="miter" strokeLinecap="square" {...p} />
      <motion.path d="M26 46 L45 22 L62 46" fill="none" stroke="var(--mth-blue)" strokeWidth="6" strokeLinejoin="miter" {...p} transition={{ ...(p.transition || {}), delay: draw ? 0.5 : 0 }} />
      <path d="M38 41 L45 33 L52 41 Z" fill="var(--mth-blue)" />
    </svg>
  );
};

export const Wordmark = ({ className = "" }) => (
  <span className={`font-display font-extrabold tracking-tight ${className}`}>
    Men<span className="text-[var(--mth-blue)]">Tell</span>Health
  </span>
);

export const Logo = ({ onClick }) => (
  <button data-testid="nav-logo" onClick={onClick} className="flex items-center gap-2.5 group">
    <LogoMark className="h-6 w-auto transition-transform duration-500 group-hover:-translate-y-0.5" />
    <Wordmark className="text-lg" />
  </button>
);
